import { GlobalOutlined } from '@ant-design/icons';
import { Space, Typography } from 'antd';
import React from 'react';

import CopyToClipboard from '../components/copy-to-clipboard';
import ExternalLink from '../components/external-link';
import { SPACING } from '../theme/tokens';

export function renderProductCode(
  productCode: string,
  warehouseProductUrl?: string,
): React.ReactElement {
  return (
    <Space size={SPACING.none} align="center">
      <Typography.Text strong>{productCode}</Typography.Text>
      <CopyToClipboard text={productCode} type="link" />
      {warehouseProductUrl ? (
        <ExternalLink
          to={warehouseProductUrl}
          ariaLabel="Open external source URL in new tab"
        />
      ) : (
        <GlobalOutlined disabled />
      )}
    </Space>
  );
}
